import React from "react";
import {DotLottieReact} from "@lottiefiles/dotlottie-react";
import {Button} from "@mui/joy";
import {useNavigate} from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <div className="containter">
            <div className="dashboard">
                <h1>Oops...</h1>
                <p>The page you are looking for could not be found</p>
                <DotLottieReact
                    src="https://lottie.host/65d92ba2-4505-401e-bf15-703e1c0bb0cc/Gfe7bZiXvf.lottie"
                    loop
                    autoplay
                    style={{height:'500px'}}
                />
                <Button onClick={() => navigate('/')}>Return Home</Button>
            </div>
        </div>
    )
}

export default NotFound;